import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';

import { loadTendersTenderAttachments } from '~src/services/api';
import { DbAttachment, DbFile } from '~src/types/db';
import { useProjectId } from '../useProjectId';
import { useArchiveSettings } from './useArchiveSettings';
import { loadSharedTendersTenderAttachments } from '~src/services/api/shares';

interface UseSharedTenderFoldersAttachmentsParams {
  share_id?: string;
  share_key?: string;
}
export const useSharedTendersTenderAttachments = (
  { share_id, share_key }: UseSharedTenderFoldersAttachmentsParams = {},
  queryConfig: QueryConfig<DbAttachment[], AxiosError> & {
    enabled?: boolean;
  } = {}
) => {
  const archiveSettings = useArchiveSettings();
  // const isTenderingOn =
  //   archiveSettings.data?.resArchiveSettings?.is_tendering_on;

  const { enabled, ...options } = queryConfig;
  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const tenderFoldersQuery = useQuery<DbAttachment[], AxiosError>(
    [
      'sharedTendersTenderAttachments',
      {
        share_id,
        share_key,
      },
    ],
    loadSharedTendersTenderAttachments,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite,
      refetchOnWindowFocus: !__DEV__,
      refetchOnMount: false,
      ...options,
    }
  );

  return tenderFoldersQuery;
};
